var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "contact-company-wrapper" },
    [
      _c(
        "ul",
        {
          staticClass: "accordion accordion-customize",
          attrs: {
            "data-accordion": "",
            "data-deep-link": "true",
            "data-allow-all-closed": "true",
            "data-multi-expand": "true",
            "data-update-history": "true",
            "data-deep-link-smudge": "500",
            id: "contact-company-accordion",
          },
        },
        [
          _c(
            "li",
            {
              staticClass: "accordion-item is-active",
              attrs: { "data-accordion-item": "" },
            },
            [
              _c("a", { staticClass: "accordion-title" }, [
                _c("span", [_vm._v(_vm._s(_vm.$t("contact.company")))]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "accordion-content",
                  attrs: { "data-tab-content": "" },
                },
                [
                  _c("table", [
                    _c("thead", [
                      _c("tr", [
                        _c("th", [_vm._v("#")]),
                        _vm._v(" "),
                        _c("th", [
                          _vm._v(_vm._s(_vm.$t("company.basic.companyName"))),
                        ]),
                        _vm._v(" "),
                        _c("th", [
                          _vm._v(_vm._s(_vm.$t("company.contactTable.title"))),
                        ]),
                        _vm._v(" "),
                        _c("th", [
                          _vm._v(
                            _vm._s(_vm.$t("company.contactTable.department"))
                          ),
                        ]),
                        _vm._v(" "),
                        _vm.isEngineer
                          ? _c("th", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("company.contactTable.propPeople")
                                )
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.contactId && _vm.isEngineer ? _c("th") : _vm._e(),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      [
                        _vm.contactId
                          ? _vm._l(
                              _vm.deep(_vm.currentContact, "companies"),
                              function (item, index) {
                                return _c("tr", { key: index }, [
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(
                                        item.type === _vm.dummyCompanyType
                                          ? _vm.$t("emptyValue")
                                          : item.id
                                      )
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _c(
                                      "a",
                                      {
                                        staticClass: "company-name",
                                        class: {
                                          link:
                                            _vm.isEngineer &&
                                            item.type !== _vm.dummyCompanyType,
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.navToCompanyView(
                                              item.id,
                                              item.type
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(item.name))]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm.allowEdit
                                      ? _c("input", {
                                          directives: [
                                            {
                                              name: "hkldinput",
                                              rawName: "v-hkldinput",
                                            },
                                          ],
                                          attrs: { type: "text" },
                                          domProps: {
                                            value: _vm.deep(
                                              item,
                                              "CompanyContact.title"
                                            ),
                                          },
                                          on: {
                                            change: function (event) {
                                              return _vm.updatePathField(
                                                index,
                                                "title",
                                                event.target.value
                                              )
                                            },
                                          },
                                        })
                                      : _c("div", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.deep(
                                                item,
                                                "CompanyContact.title"
                                              )
                                            )
                                          ),
                                        ]),
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm.allowEdit
                                      ? _c("input", {
                                          directives: [
                                            {
                                              name: "hkldinput",
                                              rawName: "v-hkldinput",
                                            },
                                          ],
                                          attrs: { type: "text" },
                                          domProps: {
                                            value: _vm.deep(
                                              item,
                                              "CompanyContact.department"
                                            ),
                                          },
                                          on: {
                                            change: function (event) {
                                              return _vm.updatePathField(
                                                index,
                                                "department",
                                                event.target.value
                                              )
                                            },
                                          },
                                        })
                                      : _c("div", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.deep(
                                                item,
                                                "CompanyContact.department"
                                              )
                                            )
                                          ),
                                        ]),
                                  ]),
                                  _vm._v(" "),
                                  _vm.isEngineer
                                    ? _c("td", [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "hkldinput",
                                              rawName: "v-hkldinput",
                                            },
                                          ],
                                          attrs: {
                                            id: "checkBox",
                                            type: "checkbox",
                                            disabled: !_vm.allowEdit,
                                          },
                                          domProps: {
                                            checked: _vm.deep(
                                              item,
                                              "CompanyContact.isPropertyPerson"
                                            )
                                              ? "checked"
                                              : "",
                                          },
                                          on: {
                                            change: function ($event) {
                                              _vm.updatePathField(
                                                index,
                                                "isPropertyPerson",
                                                !_vm.deep(
                                                  item,
                                                  "CompanyContact.isPropertyPerson"
                                                )
                                              )
                                            },
                                          },
                                        }),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.isEngineer
                                    ? _c("td", { staticClass: "icon-remove" }, [
                                        _vm.allowEdit
                                          ? _c("i", {
                                              staticClass: "fa fa-times-thin",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.openDeleteConfirm(
                                                    index
                                                  )
                                                },
                                              },
                                            })
                                          : _vm._e(),
                                      ])
                                    : _vm._e(),
                                ])
                              }
                            )
                          : _c("tr", [
                              _c("td", [
                                _vm._v(
                                  _vm._s(
                                    _vm.currentCompany.type ===
                                      _vm.dummyCompanyType
                                      ? _vm.$t("emptyValue")
                                      : _vm.currentCompany.id
                                  )
                                ),
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(_vm._s(_vm.currentCompany.name)),
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "hkldinput",
                                      rawName: "v-hkldinput",
                                    },
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.contactCompany.title,
                                      expression: "contactCompany.title",
                                    },
                                  ],
                                  attrs: { type: "text" },
                                  domProps: { value: _vm.contactCompany.title },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.contactCompany,
                                        "title",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "hkldinput",
                                      rawName: "v-hkldinput",
                                    },
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.contactCompany.department,
                                      expression: "contactCompany.department",
                                    },
                                  ],
                                  attrs: { type: "text" },
                                  domProps: {
                                    value: _vm.contactCompany.department,
                                  },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.contactCompany,
                                        "department",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                              ]),
                              _vm._v(" "),
                              _vm.isEngineer
                                ? _c("td", [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "hkldinput",
                                          rawName: "v-hkldinput",
                                        },
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value:
                                            _vm.contactCompany.isPropertyPerson,
                                          expression:
                                            "contactCompany.isPropertyPerson",
                                        },
                                      ],
                                      attrs: {
                                        id: "checkBox",
                                        type: "checkbox",
                                      },
                                      domProps: {
                                        checked: Array.isArray(
                                          _vm.contactCompany.isPropertyPerson
                                        )
                                          ? _vm._i(
                                              _vm.contactCompany
                                                .isPropertyPerson,
                                              null
                                            ) > -1
                                          : _vm.contactCompany.isPropertyPerson,
                                      },
                                      on: {
                                        change: function ($event) {
                                          var $$a =
                                              _vm.contactCompany
                                                .isPropertyPerson,
                                            $$el = $event.target,
                                            $$c = $$el.checked ? true : false
                                          if (Array.isArray($$a)) {
                                            var $$v = null,
                                              $$i = _vm._i($$a, $$v)
                                            if ($$el.checked) {
                                              $$i < 0 &&
                                                _vm.$set(
                                                  _vm.contactCompany,
                                                  "isPropertyPerson",
                                                  $$a.concat([$$v])
                                                )
                                            } else {
                                              $$i > -1 &&
                                                _vm.$set(
                                                  _vm.contactCompany,
                                                  "isPropertyPerson",
                                                  $$a
                                                    .slice(0, $$i)
                                                    .concat($$a.slice($$i + 1))
                                                )
                                            }
                                          } else {
                                            _vm.$set(
                                              _vm.contactCompany,
                                              "isPropertyPerson",
                                              $$c
                                            )
                                          }
                                        },
                                      },
                                    }),
                                  ])
                                : _vm._e(),
                            ]),
                      ],
                      2
                    ),
                  ]),
                ]
              ),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c("ActionConfirmModal", {
        ref: "deleteConfirmModal",
        attrs: {
          modalId: _vm.delConfModalId,
          confirmTitle: _vm.$t("deleteConfirmMsg"),
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }